import { SectionHeader } from '@apexinternal/ui-components'
import { Icon, Link } from '@chakra-ui/react'
import React from 'react'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { Link as ReactRouterLink } from 'react-router-dom'
import { RoutesEnum } from '../../types/RoutesEnum'

const AccountInformationHeader = ({
  accountNumber,
  isSummary,
}: {
  accountNumber: string
  isSummary: boolean
}) => {
  return (
    <SectionHeader
      tools={
        <Link
          as={ReactRouterLink}
          textColor="white"
          sx={{
            ':hover': {
              color: 'white',
            },
          }}
          to={`/${
            isSummary ? RoutesEnum.AccountDetails : RoutesEnum.AccountSummary
          }/${accountNumber}`}
        >
          {isSummary ? (
            <>
              Account Details <Icon as={FaArrowRight} />
            </>
          ) : (
            <>
              <Icon as={FaArrowLeft} /> Account Summary
            </>
          )}
        </Link>
      }
    >
      Account Information
    </SectionHeader>
  )
}

export default AccountInformationHeader
